module.exports = __webpack_public_path__ + "static/media/photo.673cf334.svg";